export default __webpack_public_path__ + "static/media/IBMOverflowMenuHorizontal.d8ec6dfa.svg";